// extracted by mini-css-extract-plugin
export default {"container":"CoordinatesSearchResults_container__PW2YP","categoryTitle":"CoordinatesSearchResults_categoryTitle__qkwo0","searchResult":"CoordinatesSearchResults_searchResult__jQ5e8"};